import { get, post, throwIfError } from 'utils/api';

export const submitScreeningApplication = async ({
  applicationId,
  floorPlanId,
  userId,
  testSubject,
  returnRentAmount,
  force,
  options,
}) => {
  const url = '/screening/application';
  const payload = {
    applicationId,
    floorPlanId,
    userId,
    testSubject,
    returnRentAmount,
    force,
  };

  const response = await post(url, payload, options);

  return throwIfError(response);
};

export const getScreeningStatus = async ({ applicationId, options }) => {
  const url = `/screening/status/${applicationId}`;
  const response = await get(url, options);

  if (response.error) {
    return response.error;
  }

  return response?.results;
};
